import { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { Shield } from '@mui/icons-material';
import { useUnitContext } from '../../context/unit';
import { useAuthContext } from '../../context/auth';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { ConfirmDialog } from '../dialogKit';
import { UNIT_TYPES } from './Add';

const Delete = ({ id, name, type }) => {
  const axiosPrivate = useAxiosPrivate();
  const { dispatch } = useUnitContext();
  const { auth } = useAuthContext();
  const [error, setError] = useState(null);
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  // Command / Regiment / Company / Outpost: same icon as in the Add and Edit dialogs
  const unitType = UNIT_TYPES[type] || { label: 'Unit', Icon: Shield };
  const label = unitType.label.toLowerCase();

  const handleDelete = async () => {
    if (!auth) {
      setError('You must be logged in');
      return;
    }

    setBusy(true);
    setError(null);
    try {
      const response = await axiosPrivate.delete(`/api/units/${id}`);
      dispatch({ type: 'DELETE_UNIT', payload: response.data });
      setShow(false);
    } catch (error) {
      setError(error.response?.data?.error || 'Delete failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Tooltip title={`Delete ${label}`}>
        <IconButton
          color="secondary"
          size="small"
          onClick={() => { setError(null); setShow(true); }}
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>

      <ConfirmDialog
        open={show}
        onClose={() => setShow(false)}
        onConfirm={handleDelete}
        busy={busy}
        error={error}
        title={`Delete ${label}?`}
        message={`The ${label} is removed from the system for every user.`}
        item={name}
        itemDetail={unitType.label}
        itemIcon={unitType.Icon}
        confirmLabel={`Delete ${label}`}
      />
    </>
  );
};

export default Delete;
